import React from 'react';
import { components } from '@peachjar/components';

const { ButtonSecondarySmall } = components.Buttons;

const OrganizationCommunication = ({
  handleOrganizationCommunicationDownloaded,
}) => (
  <React.Fragment>
    <p>
      Download the introductory template to introduce Peachjar to your community
      organizations. Just copy our template and paste into the body of your
      email.
    </p>
    <ButtonSecondarySmall
      data-testid="organizationCommunicationDownloadButton"
      href="https://cdn-assets.peachjar.com/portal-app/onboarding/Org+Communication+Template.docx"
      onClick={handleOrganizationCommunicationDownloaded}
    >
      Download Template
    </ButtonSecondarySmall>
  </React.Fragment>
);

export default OrganizationCommunication;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/components/OrganizationCommunication.jsx